export default __webpack_public_path__ + "static/media/mulheremidia.6a63e2c3.png";